<div class="w-full h-full px-5 py-3 flex flex-col justify-between">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'devices.action.connectionTestDialog.title' | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>

  <div class="flex flex-col gap-2 w-full">
    <div class="flex rounded-lg bg-[#F5F5FA]/40 p-4 mb-2">
      <div class="w-1/3 text-xs font-semibold text-neutral">
        {{ 'devices.action.connectionTestDialog.connection' | translate }}
      </div>
      <div class="w-1/3 text-xs font-semibold text-neutral">
        {{ 'devices.action.connectionTestDialog.status' | translate }}
      </div>
      <div class="w-1/3 text-xs font-semibold text-neutral">
        {{ 'devices.action.connectionTestDialog.signal_strength' | translate }}
      </div>
    </div>
    @if (isExecutingConnectionTest()) {
      <div class="flex gap-4 px-4 py-1">
        <xemex-skeleton-block [width]="'33%'" [height]="'32px'"></xemex-skeleton-block>
        <xemex-skeleton-block [width]="'33%'" [height]="'32px'"></xemex-skeleton-block>
        <xemex-skeleton-block [width]="'33%'" [height]="'32px'"></xemex-skeleton-block>
      </div>
    }
    @for (network of connectionTestResult()?.networks; track network; let i = $index) {
      <div class="flex gap-4 px-4 py-1">
        <div class="w-1/3 text-body font-light">
          {{ 'devices.action.connectionTestDialog.' + network.name | translate }}
        </div>
        @switch (network.successful) {
          @case (false) {
            <div class="w-1/3 flex items-center justify-between gap-x-1">
              <span class="font-light text-body text-crimson">{{
                'general.failed' | translate
              }}</span>
            </div>
          }
          @default {
            <div class="w-1/3 flex items-center justify-between gap-x-1">
              <span class="1/3 font-light text-body text-primary">{{
                'general.successful' | translate
              }}</span>
            </div>
          }
        }
        <div class="w-1/3 flex items-center justify-between gap-x-1">
          <span class="1/3 font-light text-body text-primary">
            {{ network.signal_strength }}
          </span>
        </div>
      </div>
    }
  </div>
  <div>
    <button mat-flat-button color="secondary" class="float-right" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </button>
  </div>
</div>
